module.exports = __webpack_public_path__ + "static/media/33.88612f84.jpg";